<script lang="ts" setup>
import CalendarService from '@/core/shared/calendar/calendar.service';
import { computed } from 'vue';

const calendarService = new CalendarService();

const props = defineProps<{
  isVideoInterview: boolean;
}>();

const showWarning = computed(() => {
  return props.isVideoInterview && calendarService.currentUserNeedsUpgrade;
});

const handleConnectClick = async () => {
  await calendarService.connectCalendar();
};
</script>

<template>
  <div class="mb-4 flex gap-4 rounded-lg bg-caution-50 p-4 text-sm font-normal" v-if="showWarning">
    <div>
      <img class="w-6" src="@/assets/svg/alert-triangle.svg" />
    </div>
    <div class="flex flex-col">
      <p class="text-caution-800">
        Add a meeting link below, or
        <a
          v-if="calendarService.calendarConnectionOauthUrl"
          :href="calendarService.calendarConnectionOauthUrl"
          class="underline"
          target="_blank"
          @click="handleConnectClick"
        >
          reconnect your calendar
        </a>
        for automatic Meet/Teams links.
      </p>
    </div>
  </div>
</template>
